import $ from 'jquery';
require('fancybox')($);
import header from '../blocks/header/header';
import preloaderPage from '../blocks/preloader_page/preloader_page';
import projects from '../blocks/projects/projects';
import recentProjects from '../blocks/recent_projects/recent_projects';
import projectsDetails from '../blocks/project_details/project_details';
import article from '../blocks/article/article';
import slider from '../blocks/slider/slider';
import partners from '../blocks/partners/partners';
import contactForm from '../blocks/contact_form/contact_form';
import Map from '../blocks/map/map';


$(() => {
  header.init();
  preloaderPage.init();
  projects.init();
  recentProjects.init();
  projectsDetails.init();
  article.init();
  slider.init();
  partners.init();
  contactForm.init();
  const map = new Map();
  map.init();

  $('a.fancybox').fancybox({
    closeBtn: false,
    arrows: true,
    nextClick: true,
    padding: 0,
    openEffect: 'elastic',
    closeEffect: 'elastic',
    nextEffect: 'elastic',
    prevEffect: 'elastic',
    caption: {
      type: 'inside',
    },
    helpers: {
      overlay: {
        closeClick: true,
        showEarly: true,
        locked: false,
      },
      thumbs: {
        thumbs: true,
      },
    },
  });

  $('a.fancyboxbig').fancybox({
    autoSize: false,
    fitToView: false,
    openEffect: 'fade',
    closeEffect: 'fade',
    nextEffect: 'fade',
    prevEffect: 'fade',
    caption: {
      type: 'inside',
    },
    helpers: {
      thumbs: true,
    },
  });

  $('.fancybox-media').fancybox({
    padding: 0,
    openEffect: 'elastic',
    closeEffect: 'elastic',
    nextEffect: 'elastic',
    prevEffect: 'elastic',
    width: 940,
    height: 528,
    arrows: false,
    helpers: {
      media: {},
      buttons: {},
    },
  });
});



/** WEBPACK FOOTER **
 ** ./src/scripts/app.js
 **/